export default [
  {
    id: 1,
    key: 'payCount',
    name: '付费次数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '<>',
      value: '<>'
    }],
    unit: '次'
  },
  {
    id: 2,
    key: 'payAmount',
    name: '付费金额',
    value: '',
    field_type: 'string',
    expression: '<>',
    equalenums: [{
      label: '<>',
      value: '<>'
    }],
    unit: '元'
  }
]
